var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlightAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 2.54198C12.9391 2.04938 13.5581 1.86028 14.0817 2.10979L18.3608 4.14866C18.8844 4.39817 19.1329 5.00059 18.9287 5.52553L14.2694 17.5032L6.49432 13.7183L12.667 2.54198Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.1849L7.07914 20.0656L6.17364 22L8.61315 21.9795L9.06595 21.0122L13.4098 18.792L6 15.1849Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightAlt);
export default __webpack_public_path__ + "static/media/highlight-alt.e8e7a0d5bc53feeddadd2b2509bb0efd.svg";
export { ForwardRef as ReactComponent };